"use strict";

var _regeneratorRuntime = require("/home/illing/code/udacity/blockchain/alpacoin/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/illing/code/udacity/blockchain/alpacoin/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/illing/code/udacity/blockchain/alpacoin/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/illing/code/udacity/blockchain/alpacoin/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var axios_1 = __importDefault(require("axios"));

var LOGMAXLEN = 120;
var DEFAULT_TIMEOUT = 15000;

var HttpWrapper = /*#__PURE__*/function () {
  function HttpWrapper() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var logreq = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    _classCallCheck(this, HttpWrapper);

    this.provider = axios_1.default.create(Object.assign({
      timeout: DEFAULT_TIMEOUT,
      headers: {
        'Content-Type': 'application/json'
      }
    }, opts));
    this.logreq = logreq;

    if (this.logreq) {
      this.provider.interceptors.response.use(function (response) {
        console.log('got response:', response.config.url, JSON.stringify(response.data).slice(0, LOGMAXLEN));
        return response;
      }, /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(error) {
          var errData, errStr, errUrl;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  errData = error.response != null ? error.response.data : {
                    error: error.message
                  };
                  errStr = (typeof errData === 'string' ? errData : JSON.stringify(errData)).slice(0, LOGMAXLEN);
                  errUrl = error.response != null ? error.response.config.url : error.address;
                  console.log('got response:', errUrl, 'err=', errStr);
                  _context.next = 6;
                  return Promise.reject(error);

                case 6:
                  return _context.abrupt("return", _context.sent);

                case 7:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }

  _createClass(HttpWrapper, [{
    key: "sendPromise",
    value: function () {
      var _sendPromise = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(url, jsonRequestData) {
        var response;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this.logreq) {
                  console.log('sending request:', url, JSON.stringify(jsonRequestData !== null && jsonRequestData !== void 0 ? jsonRequestData : {}).slice(0, LOGMAXLEN));
                }

                _context2.next = 3;
                return this.provider.request({
                  url: url,
                  method: jsonRequestData != null ? 'POST' : 'GET',
                  data: jsonRequestData
                });

              case 3:
                response = _context2.sent;
                return _context2.abrupt("return", response.data);

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function sendPromise(_x2, _x3) {
        return _sendPromise.apply(this, arguments);
      }

      return sendPromise;
    }()
  }]);

  return HttpWrapper;
}();

exports.HttpWrapper = HttpWrapper;